// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Lxsy","list":"PatternAutocomplete_list__3aQ7n"};